closeModalOutside('.modal-dialog', '[data-showmodal]');
var modalOpen = document.querySelector('div.modal-dialog.open');
var modalNotification = document.querySelector('.modal-notification');
if (modalNotification) {
    var modalNotificationID = document.querySelector('.modal-notification').dataset.modalNotificationid;
    var newsCookie = getCookie('news-' + modalNotificationID);
}

function closeModalOutside(node, activator) {
    document.addEventListener('click', function (e) {
        if (e.target == document.querySelector('.modals:not(.modal-youtubeplayer):not(.modal-notification).open')) {
            document.querySelector(".modals.open").style.transition = 'opacity .3s ease-out';
            document.querySelector(".modals.open").remove();
        }
        if (e.target == document.querySelector('.modals.modal-notification.open')) {

            document.querySelector(".modals.open").style.transition = 'opacity .3s ease-out';
            document.querySelector(".modals.open").remove();
            setCookie('news-' + modalNotificationID, modalNotificationID);
        }
    });
}

// Modal News Notification
if (modalNotification) {
    if (newsCookie != modalNotificationID) {
        setTimeout(() => {
            var newsModal = document.querySelector('.modal-notification');
            newsModal.classList.add("open");
            newsModal.querySelector('.modal-dialog').classList.add('open');
            closeModalXNotification();
        }, 6000);
    }
}

function closeModalXNotification() {
    var modalClsBtn = document.querySelector("span.modal-close");
    if (modalClsBtn) {
        modalClsBtn.addEventListener("click", function (e) {
            var parent =
                modalClsBtn.parentElement.parentElement.parentElement.parentElement;
            if (parent.classList.contains('modal-notification')) {
                setCookie('news-' + modalNotificationID, modalNotificationID);
            }
            parent.querySelector(".modal-dialog.open").classList.remove("open");
            parent.classList.remove("open");
            parent.remove();
        });
    }
}


//Close modal on X
document.addEventListener('click', function(e){
    if (e.target.classList.contains("modal-close"))
    {
        var parent = e.target.parentElement.parentElement.parentElement.parentElement;
        parent.querySelector(".modal-dialog.open").classList.remove("open");
        parent.classList.remove("open");
        parent.remove();
    }
});




// WEBPACK FOOTER //
// ./scripts/components/modals.js